{
  "fr": {
    "date": {
      "abbr_day_names": [
        "Dim",
        "Lun",
        "Mar",
        "Mer",
        "Jeu",
        "Ven",
        "Sam"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Fév",
        "Mar",
        "Avr",
        "Mai",
        "Jun",
        "Jul",
        "Aoû",
        "Sep",
        "Oct",
        "Nov",
        "Déc"
      ],
      "abbr_week": "Sem",
      "day_names": [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "long": "%d %B, %Y",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre"
      ],
      "order": [
        ":année",
        "mois",
        "jour"
      ]
    },
    "js": {
      "admin": {
        "type_form": {
          "add_group": "Ajouter un groupe d’attributs",
          "add_table": "Ajouter un tableau des lots de travaux associés",
          "custom_field": "Champ personnalisé",
          "drag_to_activate": "Faire glisser les champs ici pour les activer",
          "edit_query": "Modifier la requête",
          "inactive": "Inactif",
          "new_group": "Nouveau groupe",
          "reset_to_defaults": "Rétablir les valeurs par défaut"
        },
        "work_packages_settings": {
          "warning_progress_calculation_mode_change_from_field_to_status_html": "Passer du mode de calcul de la progression basé sur le travail au mode basé sur le statut entraînera la perte de toutes les valeurs de <i>% réalisé</i> existantes et leur remplacement par les valeurs associées à chaque statut. Les valeurs existantes pour <i>Travail restant</i> peuvent également être recalculées pour refléter ce changement. Cette action est irréversible.",
          "warning_progress_calculation_mode_change_from_status_to_field_html": "Passer du mode de calcul de la progression basé sur le statut au mode basé sur le travail transformera <i>% réalisé</i> en champ librement modifiable. Si vous complétez les champs <i>Travail</i> et <i>Travail restant</i>, ils seront également liés à <i>% réalisé</i>. Changer le champ <i>Travail restant</i> peut alors changer le <i>% réalisé</i>."
        },
        "working_days": {
          "add_non_working_day": "Jour non travaillé",
          "already_added_error": "Un jour non travaillé pour cette date existe déjà. Il ne peut y avoir qu'un seul jour non travaillé créé pour chaque date unique.",
          "calendar": {
            "empty_state_description": "Aucun jour de travail spécifique n'est défini pour cette année. Cliquez sur « + jour non travaillé » ci-dessous pour ajouter une date.",
            "empty_state_header": "Jours non travaillés",
            "new_date": "(nouveau)"
          },
          "change_button": "Enregistrer et reprogrammer",
          "change_description": "La modification des jours de la semaine considérés comme des jours ouvrables ou des jours non ouvrables peut affecter les jours de début et de fin de tous les lots de travaux et les cycles de vie de tous les projets dans ce cas.",
          "change_title": "Changer les jours travaillés",
          "removed_title": "Vous supprimerez les jours suivants de la liste des jours non travaillés :",
          "warning": "Les modifications peuvent prendre un certain temps avant de prendre effet. Vous serez informé(e) lorsque tous les lots de travaux et cycles de vie des projets concernés auront été mis à jour. Voulez-vous continuer ?\n"
        }
      },
      "ajax": {
        "hide": "Masquer",
        "loading": "Chargement…",
        "updating": "Mise à jour…"
      },
      "attachments": {
        "delete": "Supprimer la pièce jointe",
        "delete_confirmation": "Voulez-vous vraiment supprimer ce fichier ? Cette action est irréversible.\n",
        "draggable_hint": "Faites glisser le champ de l'éditeur pour incorporer une image ou une pièce jointe de référence. Les champs fermés de l'éditeur seront ouverts tant que vous continuer à faire glisser.\n",
        "quarantined_hint": "Le fichier est en quarantaine, car un virus a été détecté. Il ne peut pas être téléchargé."
      },
      "autocomplete_ng_select": {
        "add_tag": "Ajouter un élément",
        "clear_all": "Tout réinitialiser",
        "loading": "Chargement…",
        "not_found": "Aucun élément trouvé",
        "type_to_search": "Taper pour rechercher"
      },
      "autocomplete_select": {
        "active": "Activer %{label} %{name}",
        "placeholder": {
          "multi": "Ajouter «%{name} »",
          "single": "Sélectionner «%{name} »"
        },
        "remove": "Supprimer %{name}"
      },
      "autocompleter": {
        "notFoundText": "Aucun élément trouvé",
        "placeholder": "Taper pour rechercher",
        "project": {
          "placeholder": "Sélectionnez le projet"
        },
        "search": "Recherche"
      },
      "avatars": {
        "empty_file_error": "Veuillez téléverser une image valide (JPG, PNG, GIF)",
        "error_image_too_large": "L'image est trop grande.",
        "label_choose_avatar": "Choisir un avatar depuis un fichier",
        "text_upload_instructions": "Téléversez votre propre avatar personnalisé de 128 par 128 pixels. Les fichiers plus grands seront redimensionnés et recadrés pour convenir.\nUn aperçu de votre avatar sera affiché avant le téléversement, une fois que vous aurez sélectionné une image.\n",
        "uploading_avatar": "Chargement de votre avatar.",
        "wrong_file_format": "Les formats autorisés sont JPG, PNG et GIF"
      },
      "backup": {
        "attachments_disabled": "Les pièces jointes peuvent ne pas être incluses car elles dépassent la taille globale maximale autorisée. Vous pouvez modifier cela via la configuration (nécessite un redémarrage du serveur).",
        "download_backup": "Télécharger la sauvegarde",
        "include_attachments": "Inclure les pièces jointes",
        "info": "Vous pouvez déclencher une sauvegarde ici. Le processus peut prendre un certain temps en fonction de la quantité de données (en particulier les pièces jointes) que vous avez. Vous recevrez un e-mail dès qu'elle sera prête.\n",
        "last_backup": "Dernière sauvegarde",
        "last_backup_from": "Dernière sauvegarde du",
        "note": "Une nouvelle sauvegarde remplacera toute sauvegarde précédente. Il n'est possible de demander qu'un nombre limité de sauvegardes par jour.\n",
        "options": "Options",
        "request_backup": "Demander une sauvegarde",
        "title": "Sauvegarder OpenProject"
      },
      "baseline": {
        "apply": "Appliquer",
        "clear": "Effacer",
        "drop_down": {
          "a_specific_date": "une date spécifique",
          "between_two_specific_dates": "entre deux dates spécifiques",
          "last_month": "le mois dernier",
          "last_week": "la semaine dernière",
          "last_working_day": "dernier jour ouvrable",
          "none": "-",
          "yesterday": "hier"
        },
        "from": "De",
        "header_description": "Mettre en évidence les modifications apportées à cette liste depuis n'importe quel point dans le passé.",
        "help_description": "Fuseau horaire de référence pour la Référence.",
        "icon_tooltip": {
          "added": "Ajouté à la vue dans la période de temps de comparaison",
          "changed": "Maintenu avec des modifications",
          "removed": "Retiré de la vue pendant la période de temps de comparaison"
        },
        "legends": {
          "changes_between": "Modifications entre",
          "changes_since": "Modifications depuis le",
          "in_your_timezone": "Dans votre fuseau horaire local :",
          "maintained_with_changes": "Maintenu avec les modifications",
          "no_longer_meets_filter_criteria": "Ne répond plus aux critères de filtrage",
          "now_meets_filter_criteria": "Répond désormais aux critères de filtrage"
        },
        "show_changes_since": "Afficher les modifications depuis",
        "time": "Heure",
        "time_description": "Dans votre fuseau horaire : %{datetime}",
        "to": "À",
        "toggle_title": "Référence"
      },
      "bcf": {
        "add_viewpoint": "Ajouter un point de vue",
        "delete_viewpoint": "Supprimer le point de vue",
        "export": "Exporter",
        "export_bcf_xml_file": "Exporter un fichier BCF XML (BCF version 2.1)",
        "import": "Importer",
        "import_bcf_xml_file": "Importer un fichier BCF XML (BCF version 2.1)",
        "label_bcf": "BCF",
        "management": "Gestion BCF",
        "refresh": "Actualiser",
        "refresh_work_package": "Actualiser le lot de travaux",
        "show_viewpoint": "Afficher le point de vue",
        "viewpoint": "Point de vue"
      },
      "boards": {
        "add_card": "Ajouter une carte",
        "add_list": "Ajouter une liste au tableau",
        "add_list_modal": {
          "labels": {
            "assignee": "Sélectionnez l'utilisateur à ajouter en tant que nouvelle liste de destinataires",
            "status": "Sélectionnez le statut à ajouter comme nouvelle liste",
            "subproject": "Sélectionnez le sous-projet à ajouter comme nouvelle liste",
            "subtasks": "Sélectionnez le lot de travaux à ajouter comme nouvelle liste",
            "version": "Sélectionnez la version à ajouter comme nouvelle liste"
          },
          "warning": {
            "add_members": "<a href=\"%{link}\">Ajoutez un nouveau membre à ce projet</a> pour sélectionner à nouveau les utilisateurs.",
            "assignee": "Aucun membre ne correspond à votre valeur de filtre.  <br>",
            "no_member": "Ce projet n'a actuellement aucun membre à ajouter. <br>",
            "status": "Il n'y a actuellement aucun statut disponible. <br>\nSoit il n'y en a aucun ou ils ont tous déjà été ajoutés au tableau.\n"
          }
        },
        "board_type": {
          "action": "Tableau d'action",
          "action_by_attribute": "Tableau d'action (%{attribute})",
          "action_text": "Un tableau avec des listes filtrées sur l'attribut %{attribute}. Déplacer des lots de travaux vers d'autres listes mettra à jour leur attribut.\n",
          "action_text_assignee": "Tableau avec colonnes automatisées basées sur des utilisateurs assignés. Idéal pour envoyer des lots de travaux.\n",
          "action_text_status": "Tableau de style de kanban de base avec des colonnes pour des statuts tels que À faire, En cours, Terminé.\n",
          "action_text_subprojects": "Tableau avec colonnes automatiques pour les sous-projets. Glisser les lots de travaux vers d'autres listes met à jour le (sous-)projet en conséquence.\n",
          "action_text_subtasks": "Tableau avec colonnes automatiques pour les sous-éléments. Glisser les lots de travaux vers d'autres listes met à jour le parent en conséquence.\n",
          "action_text_version": "Tableau avec des colonnes automatisées basées sur l'attribut de version. Idéal pour planifier le développement d'un produit.\n",
          "action_type": {
            "assignee": "responsable",
            "status": "état",
            "subproject": "Sous-projet",
            "subtasks": "parent-enfant",
            "version": "version"
          },
          "board_type_title": {
            "assignee": "Assigné à",
            "basic": "Basique",
            "status": "Statut",
            "subproject": "Sous-projet",
            "subtasks": "Parent-enfant",
            "version": "Version"
          },
          "free": "basique",
          "free_text": "Commencez à partir de zéro avec un tableau vide. Ajoutez manuellement des cartes et des colonnes à ce tableau.\n",
          "select_attribute": "Attribut d'action",
          "select_board_type": "Veuillez choisir le type de tableau dont vous avez besoin.",
          "text": "Type de tableau"
        },
        "click_to_remove_list": "Cliquez pour supprimer cette liste",
        "configuration_modal": {
          "display_settings": {
            "card_mode": "Affichage en cartes",
            "table_mode": "Affichage en tableau"
          },
          "title": "Configurer ce tableau"
        },
        "create_new": "Créer un nouveau tableau",
        "error_attribute_not_writable": "Impossible de déplacer le lot de travaux, %{attribute} n'est pas modifiable.",
        "error_cannot_move_into_self": "Vous ne pouvez pas déplacer un lot de travaux vers sa propre colonne.",
        "error_loading_the_list": "Erreur lors du chargement de la liste : %{error_message}",
        "error_permission_missing": "La permission pour créer des requêtes publiques est manquante",
        "label_board_type": "Type de tableau",
        "label_unnamed_board": "Tableau sans nom",
        "label_unnamed_list": "Liste sans nom",
        "lists": {
          "delete": "Supprimer la liste"
        },
        "new_board": "Nouveau tableau",
        "text_hidden_list_warning": "Toutes les listes ne sont pas affichées parce que vous n'avez pas la permission. Contactez votre administrateur pour plus d'informations.",
        "version": {
          "close_version": "Fermer la version",
          "closed": "Fermé",
          "edit_version": "Éditer la version",
          "is_closed": "La version est fermée. Aucun élément ne peut être ajouté à cette version.",
          "is_locked": "La version est verrouillée. Aucun élément ne peut être ajouté à cette version.",
          "lock_version": "Verrouiller la version",
          "locked": "Verrouillé",
          "open_version": "Ouvrir la version",
          "show_version": "Afficher la version",
          "unlock_version": "Déverrouiller la version"
        }
      },
      "breadcrumb": "Fil d'Ariane",
      "button_add": "Ajouter",
      "button_add_watcher": "Ajouter observateur",
      "button_advanced_filter": "Filtre avancé",
      "button_back": "Retour",
      "button_back_to_list_view": "Retour à la liste",
      "button_cancel": "Annuler",
      "button_change_project": "Déplacer vers un autre projet",
      "button_check_all": "Tout cocher",
      "button_close": "Fermer",
      "button_close_details": "Fermer la vue détaillée",
      "button_collapse_all": "Tout replier",
      "button_configure-form": "Configurer le formulaire",
      "button_confirm": "Confirmer",
      "button_continue": "Continuer",
      "button_copy": "Copier",
      "button_copy_link_to_clipboard": "Copier le lien dans le presse-papiers",
      "button_copy_to_clipboard": "Copier dans le presse-papiers",
      "button_copy_to_other_project": "Dupliquer dans un autre projet",
      "button_create": "Créer",
      "button_custom-fields": "Champs personnalisés",
      "button_delete": "Supprimer",
      "button_delete_watcher": "Supprimer observateur",
      "button_details_view": "Vue détaillée",
      "button_duplicate": "Dupliquer",
      "button_edit": "Éditer",
      "button_expand_all": "Tout déplier",
      "button_export-atom": "Télécharger Atom",
      "button_filter": "Filtrer",
      "button_generate_pdf": "Générer un fichier PDF",
      "button_list_view": "Vue en liste",
      "button_log_costs": "Consigner coûts unitaires",
      "button_log_time": "Afficher l'horodatage",
      "button_more": "Plus",
      "button_more_actions": "Plus d'actions",
      "button_open_details": "Ouvrir la vue détaillée",
      "button_open_fullscreen": "Ouvrir l'affichage plein écran",
      "button_quote": "Citer",
      "button_save": "Enregistrer",
      "button_settings": "Paramètres",
      "button_show_cards": "Afficher la vue carte",
      "button_show_fullscreen": "Afficher la vue plein écran",
      "button_show_gantt": "Afficher la vue Gantt",
      "button_show_list": "Afficher la vue liste",
      "button_show_table": "Afficher la vue du tableau",
      "button_show_view": "Affichage plein écran",
      "button_uncheck_all": "Tout désélectionner",
      "button_update": "Mettre à jour",
      "calendar": {
        "create_new": "Créer un nouveau calendrier",
        "label_calendar_plural": "Calendriers",
        "title": "Calendrier",
        "too_many": "Il y a %{count} lots de travaux au total, mais seulement %{max} peuvent être affichés.",
        "unsaved_title": "Calendrier sans nom"
      },
      "caption_rate_history": "Historique des tarifs",
      "card": {
        "add_new": "Ajouter une nouvelle carte",
        "highlighting": {
          "entire_card_by": "Carte complète par",
          "inline": "Surligner la ligne :"
        },
        "remove_from_list": "Supprimer la carte de la liste"
      },
      "chart": {
        "axis_criteria": "Critères de l'axe",
        "errors": {
          "could_not_load": "Les données pour afficher le graphique n'ont pas pu être chargées. Les permissions nécessaires peuvent être manquantes."
        },
        "modal_title": "Configuration du graphique des lots de travaux",
        "tabs": {
          "dataset": "Ensemble de données %{number}",
          "graph_settings": "Général"
        },
        "type": "Type de graphique",
        "types": {
          "bar": "Barre",
          "doughnut": "Beignet",
          "horizontal_bar": "Barre horizontale",
          "line": "Ligne",
          "pie": "Circulaire",
          "polar_area": "Aire polaire",
          "radar": "Radar"
        }
      },
      "clipboard": {
        "browser_error": "Votre navigateur ne prend pas en charge la copie dans le presse-papiers. Veuillez effectuer la copie manuellement : %{content}",
        "copied_successful": "Copie réussie dans le presse-papiers !"
      },
      "close_filter_title": "Fermer le filtre",
      "close_form_title": "Fermer le formulaire",
      "close_popup_title": "Fermer popup",
      "custom_actions": {
        "date": {
          "current_date": "Date actuelle",
          "specific": "le"
        }
      },
      "dashboards": {
        "label": "Tableau de bord"
      },
      "description_available_columns": "Colonnes disponibles",
      "description_current_position": "Vous êtes ici : ",
      "description_select_work_package": "Sélectionner le lot de travaux #%{id}",
      "description_subwork_package": "Enfant du lot de travaux #%{id}",
      "editor": {
        "ckeditor_error": "Une erreur s'est produite dans CKEditor",
        "error_saving_failed": "L'enregistrement du document a échoué en raison de l'erreur suivante : %{error}",
        "macro": {
          "attribute_reference": {
            "invalid_attribute": "L'attribut « %{name} » n'existe pas.",
            "macro_help_tooltip": "Ce segment de texte est rendu dynamiquement par une macro.",
            "nested_macro": "Cette macro fait référence de manière récursive à %{model} %{id}.",
            "not_found": "La ressource demandée est introuvable"
          },
          "child_pages": {
            "button": "Liens vers les pages enfants",
            "hint": "Laissez ce champ vide pour répertorier toutes les pages enfants de la page actuelle. Si vous souhaitez référencer une page différente, indiquez son titre ou son slug.\n",
            "include_parent": "Inclure un parent",
            "page": "Page du wiki",
            "text": "[Placeholder] Liens vers les pages enfants de",
            "this_page": "cette page"
          },
          "code_block": {
            "button": "Insérer le fragment de code",
            "language": "Langage de formatage",
            "language_hint": "Entrez le langage de formatage qui sera utilisé pour mettre en évidence (si pris en charge).",
            "title": "Insérer/modifier le fragment de code"
          },
          "dropdown": {
            "chose_macro": "Choisir une macro",
            "macros": "Macros"
          },
          "embedded_calendar": {
            "text": "[Placeholder] Calendrier embarqué"
          },
          "embedded_table": {
            "button": "Intégrer le lot de travaux",
            "text": "[Placeholder] Tableau du lot de travaux intégré"
          },
          "error": "Impossible d'étendre la macro : %{message}",
          "toc": "Table des matières",
          "toolbar_help": "Cliquez pour sélectionner le widget et afficher la barre d’outils. Double-cliquez pour modifier le widget",
          "wiki_page_include": {
            "button": "Inclure le contenu d’une autre page wiki",
            "hint": "Incluez le contenu d’une autre page du wiki en indiquant son titre ou son slug.\nVous pouvez inclure la page wiki d'un autre projet en les séparant par un point-virgule comme dans l’exemple suivant.\n",
            "not_set": "(page non encore définie)",
            "page": "Page du wiki",
            "text": "[Placeholder] Page wiki inclue de"
          },
          "work_package_button": {
            "button": "Insérer un bouton pour créer un lot de travaux",
            "button_style": "Utiliser un style de bouton",
            "button_style_hint": "Facultatif : Cocher pour que la macro apparaisse sous forme de bouton et non de lien.",
            "type": "Type de lot de travaux",
            "with_type": "Créer un lot de travaux (Type : %{typename})",
            "without_type": "Créer un lot de travaux"
          }
        },
        "mode": {
          "manual": "Basculer en mode source Markdown",
          "wysiwyg": "Basculer vers l'éditeur WYSIWYG"
        },
        "no_revisions": "Aucune modification locale trouvée",
        "preview": "Basculer en mode aperçu",
        "revisions": "Afficher les modifications locales",
        "source_code": "Basculer en mode source Markdown"
      },
      "enumeration_activities": "Activités (suivi de temps)",
      "enumeration_doc_categories": "Catégories de documents",
      "enumeration_work_package_priorities": "Priorités des lots de travaux",
      "error": {
        "cannot_save_changes_with_message": "Impossible d’enregistrer vos modifications en raison de l’erreur suivante : %{error}",
        "embedded_table_loading": "La vue intégrée n’a pas pu être chargée : %{message}",
        "internal": "Une erreur interne s'est produite.",
        "query_saving": "La vue n'a pas pu être enregistrée."
      },
      "error_attachment_upload": "Erreur de chargement du fichier : %{error}",
      "error_attachment_upload_permission": "Vous n’avez pas l'autorisation de charger des fichiers sur cette ressource.",
      "error_could_not_resolve_user_name": "Impossible de trouver l'utilisateur",
      "error_could_not_resolve_version_name": "Ne peut résoudre le nom de version",
      "exclusion_info": {
        "modal": {
          "content": "Le statut « %{status_name} » a été configuré pour être exclu des totaux hiérarchiques du travail, du travail restant et du % réalisé. Les totaux ne tiennent pas compte de cette valeur.",
          "title": "Statut exclu des totaux de la hiérarchie"
        }
      },
      "favorite_projects": {
        "no_results": "Vous n'avez pas de projet favori",
        "no_results_subtext": "Ajoutez un ou plusieurs projets en tant que favoris via leur vue d'ensemble ou dans une liste de projets."
      },
      "field_value_enter_prompt": "Saisissez une valeur pour « %{field} »",
      "filter": {
        "description": {
          "text_close_filter": "Pour sélectionner une entrée, laissez le focus par exemple en appuyant sur Entrée. Pour quitter sans filtre, sélectionnez la première entrée (vide).",
          "text_open_filter": "Ouvrir ce filtre avec la touche « ALT » et les touches fléchées."
        },
        "more_values_not_shown": "Il y a %{total} résultats supplémentaires, effectuez une recherche pour filtrer les résultats.",
        "noneElement": "(aucun)",
        "sorting": {
          "criteria": {
            "one": "Premier critère de tri",
            "three": "Troisième critère de tri",
            "two": "Second critère de tri"
          }
        },
        "time_zone_converted": {
          "only_end": "Jusqu'à %{to} dans votre heure locale.",
          "only_start": "À partir de %{from} dans votre heure locale.",
          "two_values": "%{from} - %{to} dans votre heure locale."
        },
        "value_spacer": "-"
      },
      "forms": {
        "advanced_settings": "Paramètres avancés",
        "load_error_message": "Une erreur s'est produite lors du chargement du formulaire",
        "submit_success_message": "Le formulaire a bien été envoyé",
        "validation_error_message": "Veuillez corriger les erreurs présentes dans le formulaire"
      },
      "gantt_chart": {
        "button_activate": "Afficher le diagramme de Gantt",
        "button_deactivate": "Masquer le diagramme de Gantt",
        "filter": {
          "noneSelection": "(aucun)"
        },
        "label": "Diagramme de Gantt",
        "labels": {
          "bar": "Libellés des barres",
          "description": "Sélectionnez les attributs que vous voulez afficher dans les positions respectives du diagramme de Gantt en permanence. Notez que lorsque vous survolez un élément avec la souris, ses libellés de date seront affichés à la place de ces attributs.\n",
          "farRight": "Extrême droite",
          "left": "Gauche",
          "right": "Droite",
          "title": "Configuration du libellé"
        },
        "quarter_label": "T%{quarter_number}",
        "selection_mode": {
          "notification": "Cliquez sur n’importe quel lot de travaux mis en évidence afin de créer la relation. Appuyez sur Échap pour annuler."
        },
        "zoom": {
          "auto": "Zoom automatique",
          "days": "Jours",
          "description": "Sélectionnez le niveau de zoom initial qui devrait être affiché lorsque le zoom automatique n'est pas disponible.\n",
          "in": "Zoomer",
          "months": "Mois",
          "out": "Dézoomer",
          "quarters": "Trimestres",
          "weeks": "Semaines",
          "years": "Années"
        }
      },
      "general_text_No": "Non",
      "general_text_Yes": "Oui",
      "general_text_no": "non",
      "general_text_yes": "oui",
      "github_integration": {
        "github_actions": "Actions",
        "pull_requests": {
          "merged_message": "La requête pull #%{pr_number} %{pr_link} pour %{repository_link} a été %{pr_state} par %{github_user_link}.",
          "message": "La requête pull #%{pr_number} %{pr_link} pour %{repository_link} créée par %{github_user_link} a été %{pr_state}.",
          "referenced_message": "La requête pull #%{pr_number} %{pr_link} pour %{repository_link} créée par %{github_user_link} a référencé ce lot de travaux.",
          "states": {
            "closed": "clôturé",
            "draft": "brouillon",
            "merged": "fusionnée",
            "opened": "ouverte",
            "ready_for_review": "marquée comme prête à être révisée"
          }
        },
        "tab_header": {
          "copy_menu": {
            "description": "Copier les extraits de code git dans le presse-papiers",
            "label": "Extraits de code Git"
          },
          "git_actions": {
            "branch_name": "Nom de la branche",
            "cmd": "Créer une branche avec un commit vide",
            "commit_message": "Message de commit",
            "copy_error": "❌ La copie a échoué !",
            "copy_success": "✅ Copié !",
            "title": "Extraits de code rapides pour Git"
          },
          "title": "Demandes de pull"
        },
        "tab_prs": {
          "empty": "Il n'y a pas encore de demandes de pull liées. Liez une PR existante en utilisant le code <code>OP#%{wp_id}</code> dans la description de la PR ou créez une nouvelle PR."
        },
        "work_packages": {
          "tab_name": "GitHub"
        }
      },
      "gitlab_integration": {
        "gitlab_pipelines": "Pipelines",
        "tab_header_issue": {
          "title": "Problèmes"
        },
        "tab_header_mr": {
          "copy_menu": {
            "description": "Copier les extraits de code git dans le presse-papiers",
            "label": "Extraits de code Git"
          },
          "create_mr": {
            "description": "Créer une demande de fusion",
            "label": "Créer une MR"
          },
          "git_actions": {
            "branch_name": "Nom de la branche",
            "cmd": "Créer une branche avec un commit vide",
            "commit_message": "Message de commit",
            "copy_error": "❌ La copie a échoué !",
            "copy_success": "✅ Copié !",
            "title": "Extraits de code rapides pour Git"
          },
          "title": "Demandes de fusion"
        },
        "tab_issue": {
          "empty": "Aucun problème n'a encore été associé. Associez un problème existant en utilisant le code <code>OP#%{wp_id}</code> (ou <code>PP#%{wp_id}</code> pour les liens privés) dans le titre/la description du problème ou créez un nouveau problème."
        },
        "tab_mrs": {
          "empty": "Aucune demande de fusion (MR) n'a encore été associée. Associez une MR existante en utilisant le code <code>OP#%{wp_id}</code> (ou <code>PP#%{wp_id}</code> pour les liens privés) dans le titre/la description de la M ou créez une nouvelle MR."
        },
        "updated_on": "Mis à jour le",
        "work_packages": {
          "tab_name": "GitLab"
        }
      },
      "global_search": {
        "all_projects": "Pour tous les projets",
        "close_search": "Fermer la recherche",
        "current_project": "Pour ce projet",
        "current_project_and_all_descendants": "Dans ce projet + sous-projets",
        "recently_viewed": "Consultés récemment",
        "title": {
          "all_projects": "tous les projets",
          "project_and_subprojects": "et tous les sous-projets",
          "search_for": "Rechercher"
        }
      },
      "grid": {
        "add_widget": "Ajouter un widget",
        "configure": "Configurer le widget",
        "remove": "Supprimer le widget",
        "widgets": {
          "custom_text": {
            "title": "Texte personnalisé"
          },
          "documents": {
            "no_results": "Encore aucun document.",
            "title": "Documents"
          },
          "members": {
            "add": "Membre",
            "no_results": "Aucun membre visible.",
            "title": "Membres",
            "too_many": "%{count} membres sur %{total} affichés.",
            "view_all_members": "Afficher tous les membres"
          },
          "missing_permission": "Vous n'avez pas les autorisations nécessaires pour voir ce widget.",
          "news": {
            "at": "à",
            "no_results": "Rien de nouveau à signaler.",
            "title": "Actualités"
          },
          "project_description": {
            "no_results": "Aucune description n'a encore été écrite. Vous pouvez en trouver une dans les \"Paramètres du projet\".",
            "title": "Description du projet"
          },
          "project_favorites": {
            "no_results": "Vous n'avez actuellement aucun projet favori. Cliquez sur l'icône en forme d'étoile dans le tableau de bord du projet pour en ajouter un à vos favoris.",
            "title": "Projets favoris"
          },
          "project_status": {
            "at_risk": "À risque",
            "discontinued": "Interrompu",
            "finished": "Terminé",
            "not_set": "Non défini",
            "not_started": "Non démarré",
            "off_track": "Sur la mauvaise voie",
            "on_track": "Sur la bonne voie",
            "title": "Statut du projet"
          },
          "subprojects": {
            "no_results": "Aucun sous-projet.",
            "title": "Sous-projets"
          },
          "time_entries_current_user": {
            "displayed_days": "Jours affichés dans le widget :",
            "title": "Mon temps passé"
          },
          "time_entries_list": {
            "no_results": "Aucune entrée de temps pour les 7 derniers jours.",
            "title": "Temps passé (7 derniers jours)"
          },
          "work_packages_accountable": {
            "title": "Lots de travaux dont je suis responsable"
          },
          "work_packages_assigned": {
            "title": "Lots de travaux m'étant assignés"
          },
          "work_packages_calendar": {
            "title": "Calendrier"
          },
          "work_packages_created": {
            "title": "Lots de travaux que j'ai créés"
          },
          "work_packages_graph": {
            "title": "Graphique des lots de travaux"
          },
          "work_packages_overview": {
            "placeholder": "Cliquez pour éditer...",
            "title": "Aperçu des lots de travaux"
          },
          "work_packages_table": {
            "title": "Tableau des lots de travaux"
          },
          "work_packages_watched": {
            "title": "Lots de travaux que j'ai observés"
          }
        }
      },
      "hal": {
        "error": {
          "edit_prohibited": "La modification de %{attribute} est bloquée pour cette ressource. Soit cet attribut est dérivé de relations (ex. enfants), soit il n'est pas configurable.",
          "format": {
            "date": "%{attribute} n’est pas une date valide. Format attendu : AAAA-MM-JJ."
          },
          "general": "Une erreur s'est produite.",
          "update_conflict_refresh": "Cliquez ici pour actualiser la ressource et mettre à jour vers la version la plus récente."
        }
      },
      "help_texts": {
        "show_modal": "Afficher le texte d'aide"
      },
      "homescreen": {
        "blocks": {
          "new_features": {
            "16_3": {
              "standard": {
                "new_features_html": "Cette version contient plusieurs nouvelles fonctionnalités et améliorations, telles que <br> <ul class=\"%{list_styling_class}\"> <li>Améliorations UX/UI pour un look plus moderne.</li> <li>Réunions : option permettant de désactiver les notifications par e-mail et ICS.</li> <li>Les minuteries en cours sont affichées dans le module de suivi du temps.</li> <li>Rapport d'avancement : la somme du % d'achèvement est également affichée dans le mode basé sur l'état.</li> <li>Bilan de santé Nextcloud : indique la capacité d'échange de jetons manquante (add-on Enterprise).</li> </ul>\n"
              }
            },
            "learn_about": "En savoir plus sur les nouvelles fonctionnalités",
            "text_new_features": "En savoir plus sur les nouvelles fonctionnalités et les mises à jour des produits."
          }
        }
      },
      "ical_sharing_modal": {
        "copy_url_label": "Copier l'URL",
        "description": "Vous pouvez utiliser l'URL (iCalendar) pour vous abonner à ce calendrier dans un client externe et afficher les informations mises à jour du lot de travaux à partir de là.",
        "ical_generation_error_text": "Une erreur s'est produite lors de la génération de l'URL du calendrier.",
        "inital_setup_error_message": "Une erreur est survenue lors de la récupération des données.",
        "success_message": "L'adresse URL « %{name} » a été copiée avec succès dans votre presse-papiers. Collez-la dans votre client de calendrier pour compléter l'abonnement.",
        "title": "S'abonner au calendrier",
        "token_name_description_text": "Si vous vous abonnez à ce calendrier à partir de plusieurs appareils, ce nom vous aidera à les distinguer dans votre liste de <a href=\"my/access_token\", target=\"_blank\">jetons d'accès</a>.",
        "token_name_label": "Où comptez-vous l'utiliser ?",
        "token_name_placeholder": "Saisissez un nom, par exemple « Téléphone »",
        "warning": "Veillez à ne pas partager pas cette adresse URL avec d'autres utilisateurs. Quiconque disposant de ce lien sera en mesure de voir les détails du lot de travaux sans nécessité d'avoir un compte ou de saisir un mot de passe."
      },
      "ifc_models": {
        "empty_warning": "Ce projet n'a encore de modèle IFC pour le moment",
        "keyboard_input_disabled": "La visionneuse n'a pas de commandes de clavier. Cliquez sur la visionneuse pour lui donner le contrôle du clavier.",
        "models": {
          "ifc_models": "Modèles IFC"
        },
        "use_this_link_to_manage": "Utilisez ce lien pour téléverser et gérer vos modèles IFC",
        "views": {
          "split": "Visionneuse et tableau",
          "split_cards": "Visionneuse et cartes",
          "viewer": "Visionneuse"
        }
      },
      "include_projects": {
        "apply": "Appliquer",
        "clear_selection": "Effacer la sélection",
        "include_subprojects": "inclure tous les sous-projets",
        "no_results": "Aucun projet ne correspond à vos critères de recherche.",
        "search_placeholder": "Rechercher un projet...",
        "selected_filter": {
          "all": "Tous les projets",
          "selected": "Uniquement la sélection"
        },
        "title": "Projets",
        "toggle_title": "Inclure les projets",
        "tooltip": {
          "current_project": "Ceci est le projet dans lequel vous vous trouvez actuellement.",
          "does_not_match_search": "Le projet ne correspond pas aux critères de recherche.",
          "include_all_selected": "Projet déjà inclus puisque Include tous les sous-projets sont activés."
        }
      },
      "inplace": {
        "btn_preview_disable": "Désactiver l'aperçu",
        "btn_preview_enable": "Aperçu",
        "button_cancel": "%{attribute} : Annuler",
        "button_cancel_all": "Annuler",
        "button_edit": "%{attribute} : Modifier",
        "button_save": "%{attribute} : Enregistrer",
        "button_save_all": "Enregistrer",
        "clear_value_label": "-",
        "errors": {
          "maxlength": "%{field} ne peut pas contenir plus de %{maxLength} chiffre(s)",
          "messages_on_field": "Ce champ n’est pas valide : %{messages}",
          "minlength": "%{field} ne peut pas contenir moins de %{minLength} chiffre(s)",
          "number": "%{field} n'est pas un nombre valide",
          "required": "%{field} ne peut pas être vide"
        },
        "link_formatting_help": "Aide pour le formatage du texte",
        "null_value_label": "Aucune valeur"
      },
      "invite_user_modal": {
        "back": "Retour",
        "invite": "invite",
        "message": {
          "description": "Nous enverrons un e-mail à l'utilisateur, auquel vous pourrez ajouter un message personnel ici. Une explication concernant l'invitation pourrait être utile, ou peut-être quelques informations concernant le projet pour les aider à démarrer.",
          "label": "Message d'invitation",
          "next_button": "Suivant"
        },
        "principal": {
          "already_member_message": "Déjà membre de %{project}",
          "create_new_placeholder": "Créer un nouveau utilisateur fictif :",
          "invite_user": "Invité :",
          "label": {
            "name": "Nom",
            "name_or_email": "Nom ou adresse e-mail"
          },
          "next_button": "Suivante",
          "no_results_group": "Aucun groupe n'a été trouvé",
          "no_results_placeholder": "Aucuns utilisateurs fictifs n'a été trouvé",
          "no_results_user": "Aucun utilisateur n'a été trouvé",
          "required": {
            "group": "Veuillez sélectionner un groupe",
            "placeholder": "Veuillez sélectionner un utilisateur fictif",
            "user": "Veuillez sélectionner un utilisateur"
          }
        },
        "project": {
          "label": "Projet",
          "lacking_permission": "Veuillez sélectionner un projet différent car vous n'avez pas les autorisations nécessaires pour assigner des utilisateurs au projet actuellement sélectionné.",
          "lacking_permission_info": "Vous n'avez pas la permission d'affecter des utilisateurs au projet dans lequel vous vous trouvez. Vous devez en sélectionner un autre.",
          "next_button": "Suivante",
          "no_invite_rights": "Vous n'êtes pas autorisé à inviter des membres à ce projet",
          "no_results": "Aucun projet trouvé",
          "required": "Veuillez sélectionner un projet"
        },
        "role": {
          "description": "C'est le rôle que l'utilisateur recevra quand il rejoindra votre projet. Le rôle définit quelles actions il est autorisé à entreprendre et quelles informations il peut voir. <a href=\"https://www.openproject.org/docs/system-admin-guide/users-permissions/roles-permissions/#roles-and-permissions\" target=\"_blank\"> En savoir plus sur les rôles et les permissions. </a>",
          "label": "Rôle dans %{project}",
          "next_button": "Suivante",
          "no_roles_found": "Aucun rôle trouvé.",
          "required": "Veuillez sélectionner un rôle"
        },
        "success": {
          "description": {
            "group": "Le groupe fait maintenant partie du %{project}. Entre-temps, vous pouvez déjà planifier avec ce groupe et l'assigner des lots de travaux par exemple.",
            "placeholder": "Le utilisateur fictif peut maintenant être utilisé dans %{project}. En attendant, vous pouvez déjà planifier des taches avec cet utilisateur et l'assigner à des lots de travaux par exemple.",
            "user": "L'utilisateur peut maintenant se connecter pour accéder à %{project}. En attendant, vous pouvez déjà planifier avec cet utilisateur et assigner des lots de travaux par exemple."
          },
          "next_button": "Continuer",
          "title": "%{principal} a été invité !"
        },
        "summary": {
          "next_button": "Envoyer une invitation"
        },
        "title": {
          "Group": "groupe",
          "PlaceholderUser": "utilisateur fictif",
          "User": "utilisateur",
          "invite": "Inviter utilisateur",
          "invite_principal_to_project": "Inviter %{principal} à %{project}",
          "invite_to_project": "Inviter %{type} à %{project}"
        },
        "type": {
          "group": {
            "description": "Permissions basées sur le rôle attribué dans le projet sélectionné",
            "title": "Groupe"
          },
          "placeholder": {
            "description": "N'a pas d'accès au projet et aucun e-mail n'est envoyé.",
            "description_no_ee": "N'a pas accès au projet et aucun courriel n'est envoyé. <br>Consultez la <a href=\"%{eeHref}\" target=\"_blank\">version Entreprise</a>.",
            "title": "Utilisateur de remplacement",
            "title_no_ee": "Utilisateur fictif (add-on de la version Entreprise uniquement)"
          },
          "required": "Veuillez sélectionner le type d'invité",
          "user": {
            "description": "Permissions basées sur le rôle attribué dans le projet sélectionné",
            "title": "Utilisateur"
          }
        }
      },
      "label_activate": "Activer",
      "label_activity_show_all": "Afficher toutes les activités",
      "label_activity_show_only_comments": "Afficher les activités avec des commentaires uniquement",
      "label_add_attachments": "Joindre des fichiers",
      "label_add_column_after": "Ajouter une colonne après",
      "label_add_column_before": "Ajouter une colonne avant",
      "label_add_columns": "Ajouter des colonnes",
      "label_add_comment": "Ajouter un commentaire",
      "label_add_comment_title": "Commentez et utilisez @ pour informer d’autres personnes",
      "label_add_description": "Ajouter une description pour %{file}",
      "label_add_row_after": "Ajouter une ligne après",
      "label_add_row_before": "Ajouter une ligne avant",
      "label_add_selected_columns": "Ajouter les colonnes sélectionnées",
      "label_added_by": "ajouté par",
      "label_added_time_by": "Ajouté par <a href=\"%{authorLink}\">%{author}</a> le %{age}",
      "label_ago": "il y a",
      "label_all": "tous",
      "label_all_projects": "Tous les projets",
      "label_all_uppercase": "Tous",
      "label_all_work_packages": "tous les lots de travaux",
      "label_and": "et",
      "label_ascending": "Croissant",
      "label_assignee": "Assigné",
      "label_attachments": "Pièces jointes",
      "label_author": "Auteur : %{user}",
      "label_avatar": "Avatar",
      "label_between": "entre",
      "label_board": "Tableau",
      "label_board_locked": "Verrouillé",
      "label_board_plural": "Tableaux",
      "label_board_sticky": "Épinglé",
      "label_cancel_comment": "Annuler le commentaire",
      "label_change": "Changer",
      "label_children_derived_duration": "Durée dérivée des enfants du lot de travaux",
      "label_closed_work_packages": "clôturé",
      "label_collapse": "Replier",
      "label_collapse_all": "Tout replier",
      "label_collapsed": "replié",
      "label_columns": "Colonnes",
      "label_comment": "Commentaire",
      "label_committed_at": "%{committed_revision_link} le %{date}",
      "label_committed_link": "révision %{revision_identifier} soumise",
      "label_contains": "contenus",
      "label_create": "Créer",
      "label_create_work_package": "Créer un nouveau lot de travaux",
      "label_created_by": "Créé par",
      "label_created_on": "créé le",
      "label_current": "actuel",
      "label_custom_queries": "Privé",
      "label_date": "Date",
      "label_date_with_format": "Saisissez l'attribut %{date_attribute} en utilisant le format suivant : %{format}",
      "label_deactivate": "Désactiver",
      "label_default_queries": "Par défaut",
      "label_descending": "Décroissant",
      "label_description": "Description",
      "label_details": "Détails",
      "label_display": "Affichage",
      "label_drop_files": "Déposez des fichiers ici pour joindre des fichiers.",
      "label_drop_folders_hint": "Vous ne pouvez pas déposer les dossiers en pièces jointes. Veuillez sélectionner des fichiers seuls.",
      "label_drop_or_click_files": "Déposez des fichiers ici ou cliquez pour joindre des fichiers.",
      "label_edit_comment": "Modifier ce commentaire",
      "label_edit_status": "Modifier le statut du lot de travaux",
      "label_email": "Adresse e-mail",
      "label_equals": "est",
      "label_expand": "Déplier",
      "label_expand_all": "Tout déplier",
      "label_expand_project_menu": "Déplier le menu du projet",
      "label_expanded": "déplié",
      "label_export": "Exporter",
      "label_export_preparing": "L'export est en cours de préparation et sera téléchargé sous peu.",
      "label_favorites": "Favoris",
      "label_filename": "Fichier",
      "label_files_to_upload": "Ces fichiers vont être transférés :",
      "label_filesize": "Taille",
      "label_formattable_attachment_hint": "Insérer des fichiers en les glissant sur ce champ, ou en les collant depuis le presse-papiers.",
      "label_general": "Général",
      "label_global_queries": "Public",
      "label_greater_or_equal": ">=",
      "label_group": "Groupe",
      "label_group_by": "Grouper par",
      "label_group_plural": "Groupes",
      "label_hide_attributes": "Afficher moins",
      "label_hide_column": "Masquer la colonne",
      "label_hide_project_menu": "Replier le menu du projet",
      "label_hour": "heure",
      "label_hours": "heures",
      "label_import": "Importer",
      "label_in": "dans",
      "label_in_less_than": "dans moins de",
      "label_in_more_than": "dans plus de",
      "label_incoming_emails": "E-mails entrants",
      "label_information_plural": "Information",
      "label_invalid": "Non valide",
      "label_last_updated_on": "Dernière modification le",
      "label_latest_activity": "Dernière activité",
      "label_learn_more_link": "En savoir plus",
      "label_less_or_equal": "<=",
      "label_less_than_ago": "il y a moins de quelques jours",
      "label_loading": "Chargement…",
      "label_mail_notification": "Notifications par courriel",
      "label_manage_columns": "Gérer et réorganiser les colonnes",
      "label_me": "moi",
      "label_meeting_agenda": "Ordre du jour",
      "label_meeting_minutes": "Compte-rendu",
      "label_meetings": "Réunions",
      "label_menu_collapse": "réduire",
      "label_menu_expand": "développer",
      "label_moderate_comment": "Modérer le commentaire",
      "label_more_than_ago": "il y a plus de quelques jours",
      "label_next": "Suivante",
      "label_no_color": "Aucune couleur",
      "label_no_data": "Aucune donnée à afficher",
      "label_no_date": "pas de date",
      "label_no_due_date": "pas de date de fin",
      "label_no_start_date": "pas de date de début",
      "label_no_value": "Aucune valeur",
      "label_none": "aucune",
      "label_not_contains": "ne contient pas",
      "label_not_equals": "n'est pas",
      "label_on": "le",
      "label_open_context_menu": "Ouvrir le menu contextuel",
      "label_open_menu": "Ouvrir le menu",
      "label_open_work_packages": "ouverts",
      "label_password": "Mot de passe",
      "label_per_page": "Par page:",
      "label_please_wait": "Veuillez patienter",
      "label_press_enter_to_save": "Appuyer sur \"entrée\" pour enregistrer.",
      "label_preview": "Aperçu",
      "label_previous": "Précédent",
      "label_project": "Projet",
      "label_project_list": "Listes de projets",
      "label_project_plural": "Projets",
      "label_public_query": "Public",
      "label_quote_comment": "Citer ce commentaire",
      "label_recent": "Récent",
      "label_rejected_files": "Ces fichiers ne peuvent pas être transférés :",
      "label_rejected_files_reason": "Ces fichiers ne peuvent pas être transférés car leur taille est supérieure à %{maximumFilesize}",
      "label_remove": "Supprimer",
      "label_remove_all_files": "Supprimer tous les fichiers",
      "label_remove_column": "Supprimer la colonne",
      "label_remove_columns": "Enlever les colonnes sélectionnées",
      "label_remove_file": "Supprimer %{fileName}",
      "label_remove_row": "Supprimer la ligne",
      "label_remove_watcher": "Retirer l'observateur %{name}",
      "label_report": "Rapport",
      "label_repository_plural": "Dépôts",
      "label_reset": "Réinitialiser",
      "label_save_as": "Enregistrer sous",
      "label_search_columns": "Rechercher une colonne",
      "label_select_watcher": "Sélectionner un observateur…",
      "label_selected_filter_list": "Filtres sélectionnés",
      "label_show_attributes": "Afficher tous les attributs",
      "label_show_in_menu": "Afficher la vue dans le menu",
      "label_sort_by": "Trier par",
      "label_sort_higher": "Déplacer vers le haut",
      "label_sort_lower": "Déplacer vers le bas",
      "label_sorted_by": "trié par",
      "label_sorting": "Tri",
      "label_spent_time": "Temps passé",
      "label_star_query": "Favori",
      "label_starred_queries": "Favori",
      "label_subject": "Sujet",
      "label_sum": "Total",
      "label_sum_for": "Somme pour",
      "label_this_week": "cette semaine",
      "label_time_entry_plural": "Temps passé",
      "label_today": "Aujourd'hui",
      "label_total_amount": "Total : %{amount}",
      "label_total_progress": "%{percent}% de progression totale",
      "label_total_sum": "Somme totale",
      "label_unwatch": "Ne plus suivre",
      "label_unwatch_work_package": "Ne plus suivre le lot de travaux",
      "label_up": "Haut",
      "label_updated_on": "mis à jour le",
      "label_upload_counter": "%{done} fichiers sur %{count} finis",
      "label_upload_notification": "Chargement des fichiers...",
      "label_uploaded_by": "Téléversé par",
      "label_user_plural": "Utilisateurs",
      "label_validation_error": "Le lot de travaux n'a pas pu être enregistré en raison des erreurs suivantes :",
      "label_value_derived_from_children": "(valeur dérivée des enfants)",
      "label_version_plural": "Versions",
      "label_view_has_changed": "Cette vue a des changements non sauvegardés. Cliquez pour les enregistrer.",
      "label_visibility_settings": "Paramètres de visibilité",
      "label_wait": "Veuillez patienter pendant la configuration…",
      "label_warning": "Attention",
      "label_watch": "Suivre",
      "label_watch_work_package": "Suivre le lot de travaux",
      "label_watcher_added_successfully": "Observateur ajouté avec succès !",
      "label_watcher_deleted_successfully": "Observateur supprimé avec succès !",
      "label_work_package": "Lot de travaux",
      "label_work_package_context_menu": "Menu contextuel des lots de travaux",
      "label_work_package_details_you_are_here": "Vous êtes sur l'onglet %{tab} de %{type} %{subject}.",
      "label_work_package_parent": "Lot de Travaux parent",
      "label_work_package_plural": "Lots de Travaux",
      "label_work_package_upload_notification": "Transfert en cours des fichiers pour le lot de travaux #%{id} : %{subject}",
      "label_wp_id_added_by": "#%{id} ajouté par %{author}",
      "modals": {
        "button_apply": "Appliquer",
        "button_cancel": "Annuler",
        "button_delete": "Supprimer",
        "button_save": "Enregistrer",
        "button_submit": "Envoyer",
        "destroy_time_entry": {
          "text": "Êtes-vous sur de vouloir supprimer l'entrée de temps suivante ?",
          "title": "Confirmer la suppression de l’entrée de temps"
        },
        "destroy_work_package": {
          "bulk_text": "Voulez-vous vraiment supprimer le %{label} suivant ?",
          "confirm_deletion_children": "Je reconnais que TOUS les descendants des lots de travaux de la liste seront supprimés récursivement.",
          "deletes_children": "Tous les lots de travaux enfants et leurs descendants seront également supprimés récursivement.",
          "has_children": "Le lot de travaux a %{childUnits} :",
          "single_text": "Voulez-vous vraiment supprimer le lot de travaux",
          "title": "Confirmer la suppression de %{label}"
        },
        "form_submit": {
          "text": "Êtes-vous sûr de vouloir effectuer cette action ?",
          "title": "Confirmez pour continuer"
        },
        "label_delete_page": "Effacer la page en cours",
        "label_name": "Nom"
      },
      "myTimeTracking": {
        "noSpecificTime": "Aucune heure spécifique"
      },
      "my_page": {
        "label": "Ma page"
      },
      "notice_bad_request": "Mauvaise requête.",
      "notice_job_started": "tâche démarrée.",
      "notice_no_results_to_display": "Aucun résultat visible à afficher.",
      "notice_successful_create": "Création réussie.",
      "notice_successful_delete": "Suppression réussie.",
      "notice_successful_update": "Mise à jour réussie.",
      "notifications": {
        "center": {
          "and_more_users": {
            "one": "et 1 autre",
            "other": "et %{count} autres"
          },
          "empty_state": {
            "no_notification": "Il semble que vous êtes à jour.",
            "no_notification_for_filter": "Il semble que vous êtes à jour pour ce filtre.",
            "no_notification_with_current_filter": "Il semble que vous êtes à jour pour le filtre %{filter}.",
            "no_notification_with_current_project_filter": "Il semble que vous êtes à jour dans le projet sélectionné.",
            "no_selection": "Cliquez sur une notification pour voir tous les détails de l'activité."
          },
          "label_actor_and": "et",
          "mark_all_read": "Tout marquer comme lu",
          "mark_all_read_confirmation": "Ceci marquera toutes les notifications de cette vue comme lues. Voulez-vous continuer ?",
          "mark_as_read": "Marquer comme lu",
          "new_notifications": {
            "link_text": "Cliquez ici pour les télécharger.",
            "message": "Il y a de nouvelles notifications."
          },
          "no_results": {
            "at_all": "Les nouvelles notifications apparaîtront ici lorsqu'il y a une activité qui vous concerne.",
            "with_current_filter": "Il n'y a pas de notifications dans cette vue pour le moment"
          },
          "text_update_date_by": "%{date} par",
          "total_count_warning": "Affichage des %{newest_count} notifications les plus récentes. %{more_count} autres ne sont pas affichées."
        },
        "date_alerts": {
          "milestone_date": "Date jalon",
          "overdue": "En retard",
          "overdue_since": "depuis %{difference_in_days}.",
          "property_is": "a lieu dans %{difference_in_days}.",
          "property_is_deleted": "a été supprimée.",
          "property_today": "a lieu aujourd'hui.",
          "property_was": "avait lieu il y a %{difference_in_days}."
        },
        "no_unread": "Pas de notification non lue",
        "reasons": {
          "assigned": "Personne assignée",
          "commented": "Commenté",
          "created": "Créé",
          "dateAlert": "Alarmes",
          "mentioned": "Mentionné",
          "prioritized": "Priorisé",
          "processed": "Traité",
          "reminder": "Rappel",
          "responsible": "Responsable",
          "scheduled": "Planifié",
          "shared": "Partagé",
          "watched": "Observateur"
        },
        "reminders": {
          "note": "Note : « %{note} »"
        },
        "settings": {
          "change_notification_settings": "Vous pouvez modifier vos <a target=\"_blank\" href=\"%{url}\">paramètres de notification</a> pour vous assurer de ne jamais manquer une mise à jour importante.",
          "global": {
            "date_alerts": {
              "description": "Notifications automatiques lorsque des dates importantes approchent pour les lots de travaux ouverts vous concernant (assigné, responsable ou observateur).",
              "title": "Alertes de date"
            },
            "delayed": {
              "description": "Notifications additionnelles lors d'activités sur tous les projets.",
              "title": "Non participant"
            },
            "immediately": {
              "description": "Notifications pour toute activité sur les lots de travaux vous concernant (assigné, responsable ou observateur).",
              "title": "Participant"
            },
            "overdue": "En cas de retard"
          },
          "notify_me": "M'alerter",
          "project_specific": {
            "add": "Ajouter un paramètre pour le projet",
            "already_selected": "Ce projet est déjà sélectionné",
            "description": "Ces paramètres spécifiques au projet remplacent les paramètres par défaut ci-dessus.",
            "remove": "Suppression des paramètres de projet",
            "title": "Paramètres de notification spécifiques au projet"
          },
          "reasons": {
            "assignee": "Assigné à",
            "mentioned": {
              "description": "Recevoir une notification chaque fois que quelqu'un me mentionne n'importe où",
              "title": "Mentionné"
            },
            "responsible": "Responsable",
            "shared": "Partagé",
            "watched": "Observateur",
            "work_package_commented": "Tous les nouveaux commentaires",
            "work_package_created": "Nouveaux lots de travaux",
            "work_package_prioritized": "Tous les changements de priorité",
            "work_package_processed": "Tous les changements de statut",
            "work_package_scheduled": "Tous les changements de date"
          },
          "reminders": {
            "no_notification": "Aucune notification",
            "timeframes": {
              "normal": {
                "P1D": "1 jour avant",
                "P3D": "3 jours avant",
                "P7D": "une semaine avant",
                "PT0S": "le jour même"
              },
              "overdue": {
                "P1D": "tous les jours",
                "P3D": "tous les 3 jours",
                "P7D": "toutes les semaines"
              }
            }
          },
          "title": "Paramètres de notifications"
        },
        "title": "Notifications"
      },
      "onboarding": {
        "buttons": {
          "got_it": "J'ai compris",
          "next": "Suivante",
          "skip": "Passer"
        },
        "steps": {
          "backlogs": {
            "overview": "Gérez votre travail dans la vue <b>backlogs</b>.",
            "sprints": "Sur la droite, vous avez le backlog de produit et le backlog des bugs. Sur la gauche, vous avez leurs sprints respectifs. Ici, vous pouvez créer des <b>épopées, histoires d'utilisateurs et bugs</b>, prioriser via glisser-déposer et les ajouter à un sprint.",
            "task_board": "Le tableau des tâches visualise la <b>progression pour ce sprint</b>. Cliquez sur l'icône plus (+) à côté d'un récit utilisateur pour ajouter de nouvelles tâches ou obstacles. <br> Le statut peut être mis à jour par glisser-déposer.",
            "task_board_arrow": "Pour voir votre <b>Tableau de bord des Tâches</b>, ouvrez le menu déroulant Sprint...",
            "task_board_select": "…et sélectionnez l'entrée <b>Tableau de bord des Tâches</b>."
          },
          "boards": {
            "add": "Cliquez sur l'icône plus (+) pour <b>créer une nouvelle carte</b> ou <b>ajouter une carte existante</b> à la liste du tableau.",
            "drag": "Glissez et déposez vos cartes dans une liste donnée pour les réorganiser, ou pour les déplacer dans une autre liste. <br> Vous pouvez cliquer sur l'icône (i) dans le coin supérieur droit ou double-cliquer sur une carte pour ouvrir ses détails.",
            "lists_basic": "Ici, vous pouvez créer plusieurs listes (colonnes) dans votre tableau agile.",
            "lists_kanban": "Ici, vous pouvez créer plusieurs listes (colonnes) dans votre tableau. Cette fonctionnalité vous permet de créer un <b>tableau Kanban</b>, par exemple.",
            "overview": "Sélectionnez <b>tableaux</b> pour déplacer la vue et gérer votre projet en utilisant la vue des tableaux agiles."
          },
          "help_menu": "Le menu Aide (?) fournit des <b>ressources d'aide supplémentaires</b>. Vous y trouverez un guide utilisateur, des vidéos pratiques et plus encore. <br> Profitez de votre travail avec OpenProject !",
          "members": "Invitez de nouveaux <b>membres</b> à rejoindre votre projet.",
          "quick_add_button": "Cliquez sur l'icône plus (+) dans l'en-tête de navigation pour <b>créer un nouveau projet</b> ou <b>inviter des collègues</b>.",
          "sidebar_arrow": "Utilisez la flèche de retour dans le coin supérieur gauche pour retourner au <b>menu principal</b> du projet.",
          "team_planner": {
            "add_assignee": "Pour commencer, ajoutez des responsables au planificateur d'équipe.",
            "add_existing": "Recherchez les lots de travaux existants et faites-les glisser vers le planificateur d'équipe pour les assigner instantanément à un membre de l'équipe et définir les dates de début et de fin.",
            "calendar": "Le tableau de planification hebdomadaire ou bihebdomadaire affiche tous les lots de travaux assignés aux membres de votre équipe.",
            "card": "Faites glisser les lots de travaux horizontalement pour les déplacer vers l'arrière ou vers l'avant dans le temps, faites glisser les bords pour changer les dates de début et de fin et faites les même glisser verticalement vers une ligne différente pour les assigner à un autre membre.",
            "overview": "Le planificateur d'équipe vous permet d'assigner visuellement des tâches aux membres de l'équipe et d'obtenir un aperçu de qui travaille sur quoi."
          },
          "welcome": "Faites une visite d’introduction de trois minutes pour apprendre <b>les fonctionnalités les plus importantes</b>.<br>Il est recommandé d’effectuer les étapes jusqu'à la fin. Vous pouvez redémarrer cette visite à tout moment.",
          "wiki": "Dans le <b>wiki</b> vous pouvez documenter et partager vos connaissances avec votre équipe.",
          "wp": {
            "back_button": "Utilisez la flèche de retour dans le coin supérieur gauche pour quitter et retourner à la liste des lots de travaux.",
            "create_button": "La touche <b>+ Créer</b> ajoutera un nouveau lot de travaux à votre projet.",
            "full_view": "La vue <b>détails du lot de travaux</b> fournit toutes les informations pertinentes relatives à un lot de travaux donné, comme sa description, son statut, sa priorité, ses activités, ses dépendances et ses commentaires.",
            "gantt_menu": "Créez facilement des calendriers et des frises chronologiques pour vos projets à l'aide du module de diagramme de Gantt.",
            "list": "Cet aperçu du lot de <b>travaux</b> fournit une liste de tous les travaux de votre projet, tels que les tâches, les jalons, les phases et plus encore. <br> Les lots de travaux peuvent être créés et modifiés directement à partir de cette vue. Pour accéder aux détails d'un lot de travaux particulier, double-cliquez simplement sur sa ligne.",
            "timeline": "Ici vous pouvez <b>modifier votre plan de projet</b>, créer de nouveaux lots de travaux, comme des tâches, des jalons, des phases et plus, ainsi que <b>ajouter des dépendances</b>. Tous les membres de l'équipe peuvent voir et mettre à jour le plan le plus récent à tout moment.",
            "toggler": "Maintenant, jetons un coup d'oeil à la section <b>lot de travaux</b>, qui vous donne une vue plus détaillée de votre travail."
          }
        }
      },
      "open_project_storage_modal": {
        "waiting_subtitle": {
          "network_off": "Un problème de réseau est survenu.",
          "network_on": "Le réseau est à nouveau disponible. Nous essayons."
        },
        "waiting_title": {
          "timeout": "Délai d'inactivité"
        }
      },
      "overviews": {
        "label": "Vue globale"
      },
      "pagination": {
        "no_other_page": "Vous êtes sur la seule page.",
        "page_navigation": "Navigation par pagination",
        "pages": {
          "page_number": "Page %{number}",
          "show_per_page": "Afficher %{number} par page"
        },
        "pages_skipped": "Pages ignorées.",
        "per_page_navigation": "Sélection des éléments par page"
      },
      "password_confirmation": {
        "field_description": "Vous devez saisir le mot de passe de votre compte pour confirmer ce changement.",
        "title": "Confirmez votre mot de passe pour continuer"
      },
      "placeholders": {
        "default": "-",
        "description": "Description: Cliquez pour modifier...",
        "relation_description": "Cliquez pour ajouter la description pour cette relation",
        "selection": "Veuillez sélectionner",
        "subject": "Saisir le sujet ici"
      },
      "project": {
        "autocompleter": {
          "label": "Remplissage automatique du projet"
        },
        "click_to_switch_to_project": "Projet : %{projectname}",
        "context": "Contexte du projet",
        "not_available": "Projet N/D",
        "required_outside_context": "Veuillez choisir un projet pour créer le lot de travaux et voir tous les attributs. Vous pouvez seulement sélectionner des projets ayant le type ci-dessus activé.\n"
      },
      "project_menu_details": "Détails",
      "relation_buttons": {
        "abort": "Interrompre",
        "add_existing": "Ajouter existant",
        "add_existing_child": "Ajouter un enfant",
        "add_existing_relation": "Ajouter une relation existante",
        "add_new_child": "Créer un nouvel enfant",
        "add_new_relation": "Créer une nouvelle relation",
        "add_parent": "Ajouter un parent existant",
        "add_predecessor": "Ajouter un prédécesseur",
        "add_successor": "Ajouter un successeur",
        "change_parent": "Changer le parent",
        "create_new": "Créer nouveau",
        "group_by_relation_type": "Grouper par type de relation",
        "group_by_wp_type": "Grouper par type de lot de travaux",
        "hierarchy_indent": "Indentation de la hiérarchie",
        "hierarchy_outdent": "Supprimer l'indentation de la hiérarchie",
        "remove": "Supprimer la relation",
        "remove_child": "Supprimer enfant",
        "remove_parent": "Supprimer le parent",
        "save": "Enregistrer la relation",
        "set_parent": "Définir parent",
        "show_relations": "Afficher les relations",
        "toggle_description": "Alterner la description de relation",
        "update_description": "Définir ou mettre à jour la description de cette relation",
        "update_relation": "Cliquez pour modifier le type de relation"
      },
      "relation_labels": {
        "blocked": "Bloqué par",
        "blocks": "Bloque",
        "child": "Enfant",
        "children": "Enfants",
        "duplicated": "Dupliqué par",
        "duplicates": "Duplique",
        "follows": "Suit",
        "includes": "Comporte",
        "parent": "Parent",
        "partof": "Partie de",
        "precedes": "Précède",
        "relates": "En relation avec",
        "relation_type": "type de relation",
        "required": "Requis par",
        "requires": "Requiert"
      },
      "relations": {
        "empty": "Aucune relation n'existe",
        "remove": "Supprimer la relation"
      },
      "relations_autocomplete": {
        "parent_placeholder": "Choisissez un nouveau parent ou appuyez sur Echap pour annuler.",
        "placeholder": "Taper pour rechercher"
      },
      "relations_hierarchy": {
        "children_headline": "Enfants",
        "hierarchy_headline": "Hiérarchie",
        "parent_headline": "Parent"
      },
      "reminders": {
        "settings": {
          "alerts": {
            "document_added": "Documents ajoutés",
            "explanation": "Les notifications d'aujourd'hui sont limitées aux lots de travaux. Vous pouvez choisir de continuer à recevoir des alertes par e-mail pour ces événements jusqu'à ce qu'elles soient incluses dans les notifications:\n",
            "forum_messages": "Nouveaux messages du forum",
            "membership_added": "Adhésion ajoutée",
            "membership_updated": "Adhésion mise à jour",
            "news_added": "Actualités ajoutées",
            "news_commented": "Commenter sur une actualité",
            "title": "Alertes par e-mail pour les autres éléments (qui ne sont pas des lots de travaux)",
            "wiki_page_added": "Page wiki ajoutée",
            "wiki_page_updated": "Page wiki mise à jour"
          },
          "daily": {
            "add_time": "Ajouter une heure",
            "enable": "Activer les rappels quotidiens par e-mail",
            "explanation": "Vous ne recevrez ces rappels que pour les notifications non lues et seulement aux heures que vous spécifiez. %{no_time_zone}",
            "no_time_zone": "Jusqu'à ce que vous configurez un fuseau horaire pour votre compte, les temps seront interprétés en UTC.",
            "time_label": "Temps %{counter} :",
            "title": "Envoyez-moi des rappels quotidiens par e-mail pour les notifications non lues"
          },
          "immediate": {
            "mentioned": "Immédiatement quand quelqu'un me @mentionne",
            "personal_reminder": "Immédiatement lorsque je reçois un rappel personnel",
            "title": "Envoyez-moi un rappel par e-mail"
          },
          "pause": {
            "first_day": "Premier jour",
            "label": "Mettre temporairement en pause les rappels quotidiens par e-mail",
            "last_day": "Dernier jour"
          },
          "title": "Rappels par e-mail",
          "workdays": {
            "title": "Recevoir des rappels par e-mail ces jours"
          }
        }
      },
      "reporting_engine": {
        "label_remove": "Supprimer",
        "label_response_error": "Une erreur s'est produite lors du traitement de la requête."
      },
      "repositories": {
        "select_branch": "Sélectionner une branche",
        "select_tag": "Sélectionner une étiquette"
      },
      "revit": {
        "revit_add_in": "Module complémentaire Revit",
        "revit_add_in_settings": "Paramètres du module Revit"
      },
      "sharing": {
        "selected_count": "Sélection : %{count}",
        "selection": {
          "mixed": "Mixte"
        },
        "share": "Partager"
      },
      "sort": {
        "activate_asc": "activer pour appliquer un tri par ordre croissant",
        "activate_dsc": "activer pour appliquer un tri par ordre décroissant",
        "activate_no": "activer pour supprimer le tri",
        "sorted_asc": "Tri par ordre croissant appliqué, ",
        "sorted_dsc": "Tri par ordre décroissant appliqué, ",
        "sorted_no": "Aucun tri appliqué, ",
        "sorting_disabled": "le tri est désactivé"
      },
      "spot": {
        "drop_modal": {
          "close": "Fermer la fenêtre modale",
          "focus_grab": "Il s'agit d'une ancre de mise au point pour les fenêtres modales. Appuyez sur Maj+Tab pour revenir à l'élément de déclenchement modal."
        },
        "filter_chip": {
          "remove": "Supprimer"
        }
      },
      "storages": {
        "authentication_error": "L'authentification avec %{storageType} a échoué",
        "choose_location": "Choisir emplacement",
        "drop_files": "Déposez les fichiers ici pour les télécharger sur %{name}.",
        "drop_or_click_files": "Déposez des fichiers ici ou cliquez pour les télécharger sur %{name}.",
        "file_links": {
          "already_linked_directory": "Ce répertoire est déjà lié à ce lot de travaux.",
          "already_linked_file": "Ce fichier est déjà lié à ce lot de travaux.",
          "download": "Télécharger %{fileName}",
          "empty": "Il n'y a actuellement aucun fichier lié à ce lot de travaux. Commencez à lier les fichiers avec l'action ci-dessous ou à partir de %{storageType}.\n",
          "link_uploaded_file_error": "Une erreur s'est produite lors de la liaison du fichier '%{fileName}' récemment déposé sur le lot de travaux %{workPackageId}.\n",
          "open": "Ouvrir le fichier sur le stockage",
          "open_location": "Ouvrir le fichier à l'emplacement",
          "remove": "Supprimer le lien de fichier",
          "remove_confirmation": "Êtes-vous sûr de vouloir dissocier le fichier de ce lot de travaux ? La suppression du lien n'affecte pas le fichier original et supprime seulement la connexion à ce lot de travaux.\n",
          "remove_short": "Supprimer le lien",
          "select": "Sélectionner les fichiers",
          "select_all": "Tout sélectionner",
          "selection": {
            "one": "Lier un fichier",
            "other": "Lier %{count} fichiers",
            "zero": "Sélectionner les fichiers à lier"
          },
          "success_create": {
            "one": "Un lien de fichier a été créé avec succès.",
            "other": "%{count} liens de fichier ont été créés avec succès."
          },
          "tooltip": {
            "not_found": "Impossible de trouver ce fichier.",
            "not_logged_in": "Veuillez vous connecter au stockage pour accéder à ce fichier.",
            "view_not_allowed": "Vous n'avez pas la permission de voir ce fichier."
          },
          "upload_error": {
            "403": "Votre fichier (%{fileName}) n'a pas pu être téléversé en raison de restrictions du système. Veuillez contacter votre administrateur pour obtenir plus d'informations.\n",
            "413": "Votre fichier (%{fileName}) a une taille supérieure à la taille limite que OpenProject peut téléverser sur %{storageType}. Vous pouvez d'abord téléverser le fichier directement sur %{storageType}, puis le lier.\n",
            "507": "Votre fichier (%{fileName}) a une taille supérieure au quota de stockage autorisé. Contactez votre administrateur pour modifier ce quota.\n",
            "default": "Votre fichier (%{fileName}) n'a pas pu être téléchargé.\n",
            "detail": {
              "nextcloud": "Veuillez vérifier que la dernière version de l'application Nextcloud \"OpenProject Integration\" est installée et contactez votre administrateur pour plus d'informations.\n"
            }
          }
        },
        "files": {
          "already_existing_body": "Un fichier avec le nom « %{fileName} » existe déjà à l'emplacement où vous essayez de téléverser ce fichier. Que voulez-vous faire ?\n",
          "already_existing_header": "Ce fichier existe déjà",
          "cannot_create_folder": "Échec de la création du dossier. Évitez d'utiliser des caractères spéciaux et des symboles, et assurez-vous que le dossier n'existe pas déjà.",
          "directory_not_writeable": "Vous n'avez pas la permission d'ajouter des fichiers à ce dossier.",
          "dragging_folder": "Le téléversement vers %{storageType} ne prend pas en charge les dossiers.",
          "dragging_many_files": "Le dépôt vers %{storageType} ne supporte qu'un seul fichier à la fois.",
          "empty_folder": "Ce dossier est vide.",
          "empty_folder_location_hint": "Cliquez sur le bouton ci-dessous pour téléverser le fichier à cet endroit.",
          "file_not_selectable_location": "La sélection d'un fichier est impossible pendant le processus de sélection d'un emplacement.",
          "managed_project_folder_no_access": "Vous n'avez pas encore accès au dossier de projet géré. Veuillez patienter un peu avant de réessayer.\n",
          "managed_project_folder_not_available": "Le dossier de projet géré automatiquement n'a pas encore été trouvé. Veuillez patienter, rechargez la page pour récupérer les données les plus récentes, puis réessayez.\n",
          "project_folder_no_access": "Vous n'avez pas accès au dossier du projet. Veuillez contacter votre administrateur pour avoir accès ou téléverser le fichier vers un autre endroit.\n",
          "upload_keep_both": "Garder les deux",
          "upload_replace": "Remplacer"
        },
        "information": {
          "authentication_error": "Erreur : la requête à %{storageType} n'a pas pu être authentifiée.",
          "connection_error": "Certains paramètres de %{storageType} ne fonctionnent pas. Veuillez contacter votre administrateur %{storageType}.\n",
          "live_data_error": "Erreur lors de la récupération des détails du fichier",
          "live_data_error_description": "Certaines données de %{storageType} n'ont pas pu être récupérées. Essayez de recharger cette page ou contactez votre administrateur %{storageType}.\n",
          "no_file_links": "Afin de lier des fichiers à ce lot de travaux, veuillez le faire via %{storageType}.",
          "not_logged_in": "Pour ajouter un lien, voir ou téléverser des fichiers liés à ce lot de travaux, veuillez vous connecter à %{storageType}.\n",
          "suggest_logout": "Vous pouvez essayer de vous déconnecter et de revenir pour tenter de résoudre le problème.",
          "suggest_relink": "Vous pouvez essayer de réassocier votre compte via le bouton de connexion ci-dessous pour résoudre ce problème."
        },
        "link_existing_files": "Lier des fichiers existants",
        "link_files_in_storage": "Lier des fichiers dans %{storageType}",
        "login": "Connexion à %{storageType}",
        "login_to": "Connexion à %{storageType}",
        "new_folder": "Nouveau dossier",
        "no_connection": "Aucune connexion à %{storageType}",
        "open_storage": "Ouvrir %{storageType}",
        "select_location": "Sélectionnez l'emplacement",
        "types": {
          "default": "Stockage",
          "nextcloud": "Nextcloud",
          "one_drive": "OneDrive/SharePoint"
        },
        "upload_files": "Charger des fichiers"
      },
      "team_planner": {
        "add_assignee": "Attributaire",
        "add_existing": "Ajouter existant",
        "add_existing_title": "Ajouter des lots de travaux existants",
        "cannot_drag_here": "Impossible de supprimer le lot de travaux en raison des autorisations ou des restrictions d'édition.",
        "cannot_drag_to_non_working_day": "Ce lot de travaux ne peut pas démarrer/terminer sur un jour non ouvré.",
        "create_label": "Planificateur d'équipe",
        "create_title": "Créer un nouveau planificateur d'équipe",
        "drag_here_to_remove": "Faites glisser ici pour supprimer le responsable et les dates de début et de fin.",
        "eight_weeks": "8 semaines",
        "four_weeks": "4 semaines",
        "label_team_planner_plural": "Planificateurs d'équipe",
        "modify": {
          "errors": {
            "fallback": "Ce lot de travaux ne peut pas être modifié.",
            "permission_denied": "Vous n’avez pas les autorisations nécessaires pour modifier ceci."
          }
        },
        "no_data": "Ajoutez des personnes pour configurer votre planificateur d'équipe.",
        "one_week": "1 semaine",
        "quick_add": {
          "empty_state": "Utilisez le champ de recherche pour trouver des lots de travaux et faites-les glisser vers le planificateur pour l'assigner à quelqu'un et définir des dates de début et de fin.",
          "search_placeholder": "Rechercher..."
        },
        "remove_assignee": "Retirer l'assigné",
        "today": "Aujourd'hui",
        "two_weeks": "2 semaines",
        "unsaved_title": "Planificateur d'équipe sans nom",
        "work_week": "Semaine de travail"
      },
      "text_are_you_sure": "Êtes-vous sûr ?",
      "text_are_you_sure_to_cancel": "Vous avez des modifications non enregistrées sur cette page. Êtes-vous sûr de vouloir les supprimer ?",
      "text_data_lost": "Toutes les données saisies seront perdues.",
      "text_query_destroy_confirmation": "Êtes-vous sûr de vouloir supprimer la vue sélectionnée ?",
      "text_user_wrote": "%{value} écrit:",
      "text_work_packages_destroy_confirmation": "Êtes-vous sûr de vouloir supprimer le(s) lot(s) de travaux sélectionné(s) ?",
      "time_entry": {
        "stop": "Arrêter",
        "title": "Consigner temps",
        "tracking": "Suivi du temps",
        "work_package_required": "Nécessite d'abord la sélection d'un lot de travaux."
      },
      "timer": {
        "button_stop": "Arrêter la minuterie actuelle",
        "start_new_timer": "Démarrer une nouvelle minuterie",
        "timer_already_running": "Pour démarrer une nouvelle minuterie, vous devez d'abord arrêter la minuterie actuelle :",
        "timer_already_stopped": "Aucune minuterie active pour ce lot de travaux, l'avez-vous arrêtée dans une autre fenêtre ?",
        "tracking_time": "Temps de suivi"
      },
      "tl_toolbar": {
        "outlines": "Niveau de hiérarchie",
        "zooms": "Niveau de zoom"
      },
      "toolbar": {
        "filter": "Filtrer",
        "search_query_label": "Rechercher les vues enregistrées",
        "settings": {
          "columns": "Colonnes",
          "configure_view": "Configurer la vue",
          "delete": "Supprimer",
          "display_hierarchy": "Afficher la hiérarchie",
          "display_sums": "Afficher les sommes",
          "export": "Exporter",
          "group_by": "Grouper par",
          "hide_hierarchy": "Masquer la hiérarchie",
          "hide_sums": "Masquer les sommes",
          "page_settings": "Renommer la vue",
          "save": "Enregistrer",
          "save_as": "Enregistrer sous",
          "share_calendar": "S'abonner au calendrier",
          "sort_by": "Trier par",
          "visibility_settings": "Paramètres de visibilité"
        },
        "unselected_title": "Lot de travaux"
      },
      "two_factor_authentication": {
        "errors": {
          "aborted": "L'authentification a été annulée. Veuillez réessayer."
        },
        "label_two_factor_authentication": "Authentification à deux facteurs"
      },
      "types": {
        "attribute_groups": {
          "confirm_reset": "Avertissement : êtes-vous sûr de vouloir réinitialiser la configuration du formulaire ? Ceci va réinitialiser les attributs à leur groupe par défaut et désactiver TOUS les champs personnalisés.\n",
          "error_duplicate_group_name": "Le nom %{group} est utilisé plus d’une fois. Les noms de groupe doivent être uniques.",
          "error_no_table_configured": "Veuillez configurer un tableau pour %{group}.",
          "more_information": "Plus d'informations",
          "nevermind": "Peu importe",
          "reset_title": "Réinitialiser la configuration du formulaire",
          "upgrade_to_ee": "Mettre à niveau vers la version Entreprise autohébergée",
          "upgrade_to_ee_text": "Waouh ! Si vous avez besoin de cette fonctionnalité, vous êtes un véritable pro ! Cela vous dérangerait-il de soutenir les développeurs Open Source en devenant un client de la version Entreprise ?"
        }
      },
      "units": {
        "child_work_packages": {
          "one": "un lot de travaux enfant",
          "other": "%{count} lots de travaux enfant"
        },
        "day": {
          "one": "1 jour",
          "other": "%{count} jours",
          "zero": "0 jour"
        },
        "hour": {
          "one": "1h",
          "other": "%{count} h",
          "zero": "0 h"
        },
        "word": {
          "one": "1 mot",
          "other": "%{count} mots"
        },
        "workPackage": {
          "one": "lot de travaux",
          "other": "lots de travaux"
        }
      },
      "upsell": {
        "ee_only": "Add-on de l'édition entreprise"
      },
      "views": {
        "card": "Cartes",
        "list": "Tableau",
        "timeline": "Gantt"
      },
      "watchers": {
        "label_add": "Ajouter des observateurs",
        "label_discard": "Supprimer la sélection",
        "label_error_loading": "Une erreur s'est produite lors du chargement des observateurs",
        "label_loading": "observateurs en cours de chargement…",
        "label_search_watchers": "Rechercher des observateurs",
        "typeahead_placeholder": "Rechercher les observateurs potentiels"
      },
      "wiki_formatting": {
        "code": "Code Inline",
        "deleted": "Supprimé",
        "heading1": "Titre 1",
        "heading2": "Titre 2",
        "heading3": "Titre 3",
        "image": "Image",
        "italic": "Italique",
        "ordered_list": "Liste ordonnée",
        "preformatted_text": "Texte préformaté",
        "quote": "Citer",
        "strong": "Gras",
        "underline": "Souligné",
        "unordered_list": "Liste non ordonnée",
        "unquote": "Annuler la citation",
        "wiki_link": "Lien vers une page wiki"
      },
      "work_packages": {
        "baseline": {
          "addition_label": "Ajouté à la vue dans la période de temps de comparaison",
          "column_incompatible": "Cette colonne n'affiche pas les changements en mode Référence.",
          "modification_label": "Modifié dans la période de temps de comparaison",
          "removal_label": "Retiré de la vue pendant la période de temps de comparaison"
        },
        "bulk_actions": {
          "delete": "Supprimer en bloc",
          "duplicate": "Duplication groupée",
          "edit": "Édition en bloc",
          "move": "Changement de projet en bloc"
        },
        "button_clear": "Effacer",
        "comment_added": "Le commentaire a été ajouté avec succès.",
        "comment_send_failed": "Une erreur s'est produite. Impossible de soumettre le commentaire.",
        "comment_updated": "Le commentaire a été mis à jour avec succès.",
        "confirm_edit_cancel": "Êtes-vous sûr de vouloir annuler l'édition du lot de travaux ?",
        "create": {
          "button": "Créer",
          "header": "Nouveau lot (%{type})",
          "header_no_type": "Nouveau lot de travaux (type non encore spécifié)",
          "header_with_parent": "Nouveau %{type} (enfant de %{parent_type} #%{id})",
          "title": "Nouveau lot de travaux"
        },
        "default_queries": {
          "all_open": "Tous les ouverts",
          "assigned_to_me": "Assigné à moi",
          "created_by_me": "Créé par moi",
          "latest_activity": "Dernière activité",
          "manually_sorted": "Nouvelle requête triée manuellement",
          "milestones": "Étapes importantes",
          "overdue": "En retard",
          "recently_created": "Créé récemment",
          "shared_with_me": "Partagés avec moi",
          "shared_with_users": "Partagés avec des utilisateurs",
          "summary": "Résumé"
        },
        "description_enter_text": "Saisir texte",
        "description_filter": "Filtrer",
        "description_options_hide": "Masquer les options",
        "description_options_show": "Afficher les options",
        "duplicate": {
          "title": "Dupliquer les lots de travaux"
        },
        "edit_attribute": "%{attribute} - Éditer",
        "faulty_query": {
          "description": "Votre vue est erronée et n'a pas pu être traitée.",
          "title": "Les lots de travaux n'ont pas pu être chargés."
        },
        "filters": {
          "baseline_incompatible": "Cet attribut de filtre n'est pas pris en compte en mode Référence.",
          "baseline_warning": "Le mode Référence est activé, mais certains de vos filtres actifs ne sont pas inclus dans la comparaison.",
          "title": "Filtrer les lots de travaux"
        },
        "hierarchy": {
          "children_collapsed": "Niveau de hiérarchie %{level}, replié. Cliquez pour afficher les enfants filtrés",
          "children_expanded": "Niveau de hiérarchie %{level}, déplié. Cliquez pour replier les enfants filtrés",
          "hide": "Masquer le mode hiérarchie",
          "leaf": "Dépendance du lot de travaux au niveau %{level}.",
          "show": "Afficher le mode hiérarchie",
          "toggle_button": "Cliquez pour changer de mode hiérarchique."
        },
        "inline_create": {
          "title": "Cliquez ici pour ajouter un nouveau lot de travaux à cette liste"
        },
        "jump_marks": {
          "content": "Aller au contenu",
          "label_content": "Cliquez ici pour passer le menu et aller au contenu",
          "label_pagination": "Cliquez ici pour sauter le tableau des lots de travaux et accéder à la pagination",
          "pagination": "Passer à la pagination du tableau"
        },
        "key_value": "%{key} : %{value}",
        "label_column_multiselect": "Champ liste déroulante combinée : sélectionner avec les touches fléchées, confirmer la sélection avec la touche enter, supprimer avec retour arrière",
        "label_disable_multi_select": "Désactiver la sélection multiple",
        "label_enable_multi_select": "Activer la sélection multiple",
        "label_filter_add": "Ajouter le filtre",
        "label_filter_by_text": "Filtrer par texte",
        "label_gantt_chart_plural": "Diagrammes de Gantt",
        "label_options": "Options",
        "limited_results": "Seuls %{count} lots de travaux peuvent être affichés en mode de tri manuel. Veuillez réduire les résultats par filtrage, ou passer au tri automatique.",
        "message_error_during_bulk_delete": "Une erreur s'est produite lors de la tentative de suppression des lots de travaux.",
        "message_successful_bulk_delete": "Les lots de travaux ont été correctement supprimés.",
        "message_successful_show_in_fullscreen": "Cliquez ici pour ouvrir ce lot de travaux en affichage plein écran.",
        "message_view_spent_time": "Afficher le temps passé pour ce lot de travaux",
        "message_work_package_read_only": "Paquet de travail est verrouillé. Aucun attribut autre que l’État ne peut être modifié.",
        "message_work_package_status_blocked": "Le statut du lot de travail n'est pas modifiable en raison de la fermeture du statut et de la version assignés.",
        "no_results": {
          "description": "Soit aucun n'a été créé, soit tous les lots de travaux sont filtrés.",
          "title": "Aucun lot de travaux à afficher."
        },
        "placeholder_filter_by_text": "Objet, description, commentaires, ...",
        "placeholders": {
          "date": "Sélectionnez la date",
          "default": "-"
        },
        "progress": {
          "title": "Estimation des travaux et de la progression"
        },
        "properties": {
          "assignee": "Assigné à",
          "author": "Auteur",
          "category": "Catégorie",
          "costObject": "Budget",
          "createdAt": "Créé le",
          "date": "date",
          "description": "Description",
          "dueDate": "Date de fin",
          "duration": "Durée",
          "overallCosts": "Coûts globaux",
          "percentComplete": "% réalisé",
          "percentCompleteAlternative": "Progression",
          "percentageDone": "Pourcentage effectué",
          "priority": "Priorité",
          "projectName": "Projet",
          "remainingTime": "Travail restant",
          "remainingWork": "Travail restant",
          "remainingWorkAlternative": "Heures restantes",
          "responsible": "Responsable",
          "spentTime": "Temps passé",
          "spentUnits": "Unités consommées",
          "startDate": "Date de début",
          "status": "Statut",
          "storyPoints": "Points d'histoire",
          "subject": "Sujet",
          "subproject": "Sous-projet",
          "title": "Titre",
          "type": "Type",
          "updatedAt": "Mis à jour le",
          "version": "Version",
          "versionName": "Version",
          "work": "Travail",
          "workAlternative": "Durée estimée"
        },
        "property_groups": {
          "costs": "Coûts",
          "details": "Détails",
          "estimatesAndTime": "Estimations et temps",
          "other": "Autre",
          "people": "Participants"
        },
        "query": {
          "click_to_edit_query_name": "Cliquez ici pour modifier le titre de cette présentation.",
          "column_names": "Colonnes",
          "confirm_edit_cancel": "Êtes-vous sûr de vouloir annuler la modification du nom de cette vue ? Le titre sera redéfini selon la valeur précédente.",
          "display_sums": "Afficher les sommes",
          "errors": {
            "duplicate_query_title": "Le nom de cette vue existe déjà. Changer quand même ?",
            "not_found": "Cette vue n'existe pas",
            "unretrievable_query": "Impossible de récupérer la vue par l'URL"
          },
          "filters": "Filtres",
          "group": "Grouper par",
          "group_by": "Grouper les résultats par",
          "group_by_disabled_by_hierarchy": "Grouper par est désactivé, car le mode hiérarchie est activé.",
          "hide_column": "Masquer la colonne",
          "hierarchy_disabled_by_group_by": "Le mode hiérarchie est désactivé, car les résultats sont groupés par %{column}.",
          "insert_columns": "Insérer des colonnes",
          "move_column_left": "Déplacer la colonne à gauche",
          "move_column_right": "Déplacer la colonne à droite",
          "public_text": "Publier cette vue, permet aux autres utilisateurs d'accéder à votre vue. Les utilisateurs ayant l'autorisation de 'Gérer les vues publiques' peuvent modifier ou supprimer une requête publique. Cela n'affecte pas la visibilité des résultats des lots de travaux dans cette vue et, selon leurs permissions, les utilisateurs peuvent voir des résultats différents.\n",
          "rename_query_placeholder": "Nom de cette vue",
          "sort_ascending": "Trier par ordre croissant",
          "sort_descending": "Trier par ordre décroissant",
          "star_text": "Marquez cette vue comme favorite et ajoutez-la à la barre latérale des vues enregistrées sur la gauche.",
          "text_no_results": "Aucune vue correspondante n'a été trouvée."
        },
        "reminders": {
          "button_label": "Définir un rappel",
          "presets": {
            "custom": "À une date/heure particulière",
            "month": "Dans un mois",
            "three_days": "Dans 3 jours",
            "tomorrow": "Demain",
            "week": "Dans une semaine"
          },
          "subtitle": "Vous recevrez une notification pour ce lot de travaux au moment choisi.",
          "title": {
            "edit": "Modifier un rappel",
            "new": "Définir un rappel"
          }
        },
        "scheduling": {
          "is_parent": "Les dates de ce lot de travaux sont automatiquement déduites de ses enfants. Activez la « Planification manuelle » pour définir les dates.",
          "is_switched_from_manual_to_automatic": "Les dates de ce lot de travaux peuvent avoir besoin d'être recalculées après avoir passé de la planification manuelle à la planification automatique en raison de relations avec d'autres lots de travaux."
        },
        "sharing": {
          "show_all_users": "Afficher tous les utilisateurs avec lesquels le lot de travaux a été partagé",
          "title": "Partager le lot de travaux"
        },
        "table": {
          "configure_button": "Configurer le tableau du lot de travaux",
          "summary": "Tableau avec lignes de lots de travaux et colonnes d’attributs de lots de travaux.",
          "text_inline_edit": "La plupart des cellules de ce tableau sont des boutons qui activent la fonctionnalité d'édition en ligne de l’attribut.",
          "text_select_hint": "Les boîtes de sélection doivent être ouvertes avec la touche « ALT » et les flèches directionelles.",
          "text_sort_hint": "Avec les liens dans les entêtes de tableau, vous pouvez trier, regrouper, réorganiser, supprimer et ajouter des colonnes."
        },
        "table_configuration": {
          "button": "Configurer ce tableau du lot de travaux",
          "choose_display_mode": "Afficher les lots de travaux comme",
          "columns_help_text": "Utilisez le champ de saisie ci-dessus pour ajouter des colonnes à votre vue de tableau. Vous pouvez glisser-déposer les colonnes pour les réorganiser.",
          "default": "défaut",
          "default_mode": "Liste ombrée",
          "display_settings": "Paramètres d'affichage",
          "display_sums_hint": "Afficher les sommes de tous les attributs sommables dans une ligne sous les résultats du tableau.",
          "embedded_tab_disabled": "Cet onglet de configuration n'est pas disponible pour la vue intégrée que vous êtes en train de modifier.",
          "hierarchy_hint": "Tous les résultats du tableau filtrés seront augmentés de leurs ancêtres . Les hiérarchies peuvent être dépliées et repliées.",
          "hierarchy_mode": "Hiérarchie",
          "highlighting": "Surlignement",
          "highlighting_mode": {
            "description": "Surligner avec de la couleur",
            "entire_row_by": "Ligne entière selon",
            "inline": "Attribut(s) en surbrillance",
            "inline_all": "Tous les attributs",
            "none": "Pas de surlignement",
            "priority": "Priorité",
            "status": "Statut",
            "type": "Type"
          },
          "modal_title": "Configuration du tableau du lot de travaux",
          "relation_filters": {
            "filter_work_packages_by_relation_type": "Filtrer les lots de travaux par type de relation"
          },
          "show_timeline_hint": "Afficher un diagramme de Gantt interactif sur le côté droit du tableau. Vous pouvez modifier sa largeur en faisant glisser le séparateur entre le tableau et le diagramme de Gantt.",
          "sorting_mode": {
            "automatic": "Automatique",
            "description": "Choisissez le mode pour trier vos lots de travaux :",
            "manually": "Manuellement",
            "warning": "Vous perdrez votre tri précédent lors de l'activation du mode de tri automatique."
          }
        },
        "tabs": {
          "activity": "Activité",
          "files": "Fichiers",
          "github": "GitHub",
          "gitlab": "GitLab",
          "meetings": "Réunions",
          "overview": "Vue globale",
          "relations": "Relations",
          "watchers": "Observateurs"
        },
        "time_relative": {
          "days": "jours",
          "months": "mois",
          "weeks": "semaines"
        }
      },
      "zen_mode": {
        "button_activate": "Activer le mode zen",
        "button_deactivate": "Désactiver le mode zen"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": " ",
          "format": "%n %u",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "milliard",
            "million": "million",
            "quadrillion": "million de milliards",
            "thousand": "millier",
            "trillion": "billion",
            "unit": null
          }
        },
        "format": {
          "delimiter": null,
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Octet",
              "other": "Octets"
            },
            "eb": "Eo",
            "gb": "Go",
            "kb": "ko",
            "mb": "Mo",
            "pb": "Po",
            "tb": "To",
            "zb": "ZB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": null,
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": null
        }
      }
    },
    "time": {
      "am": "matin",
      "formats": {
        "default": "%Y-%m-%d %H-%M-%S",
        "long": "%B %d, %Y %H:%M:%S",
        "short": "%d %b %H:%M:%S",
        "time": "%H:%M:%S"
      },
      "pm": "après-midi"
    }
  }
}